import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import CustomTooltip from './CustomTooltip';
import { CLASSROOM_STATE } from '../../const';
import { prettyName } from '../../utils/stringUtils';
import { I18n } from 'react-redux-i18n-lite';
import MoreOptions from './sheets/MoreOptions';

class CardLarge extends React.Component {
  static propTypes = {
    textTop: PropTypes.string.isRequired,
    textBottom: PropTypes.string.isRequired,
    entryPoint: PropTypes.string.isRequired,
    img: PropTypes.string,
    id: PropTypes.any.isRequired,
    isDragging: PropTypes.bool,
    optionItems: PropTypes.array.isRequired,
    type: PropTypes.any,
    renderLoadBar: PropTypes.any
  };

  constructor(props, context) {
    super(props, context);
    this.checkEnabled = this.checkEnabled.bind(this);
  }

  checkEnabled(e) {
    const { isDragging } = this.props;
    if (isDragging) e.preventDefault();
  }

  renderDropDown() {
    const { id, optionItems, textTop, img } = this.props;
    if (optionItems.length > 0) {
      // Desktop: dropdown; mobile: bottom sheet headed by the card
      return (
        <MoreOptions
          id={`${id}`}
          color="gray"
          dropdownSide="left"
          options={optionItems}
          sheetTitle={textTop}
          sheetOverline={I18n.t('mobileSheets.classroom')}
          sheetMedia={
            img ? <span className="sheet-media-image" style={{ backgroundImage: `url(${img})` }} /> : undefined
          }
        />
      );
    }
  }

  renderImg(img) {
    return img ? <img src={img} alt="presentation" /> : <div className="no-image" />;
  }

  renderBookname = bookName => {
    return <div className="name"> {bookName} </div>;
  };

  renderTooltipWrapper = (title, children) => {
    return <CustomTooltip title={title}>{children}</CustomTooltip>;
  };

  render() {
    const { textTop, textBottom, entryPoint, img, type, renderLoadBar } = this.props;
    const to = type === CLASSROOM_STATE.ACTIVE.state ? entryPoint : '';
    let showTooltip = false;
    let bookPrettyName = prettyName(textTop, 38);
    if (textTop.length > 38) {
      showTooltip = true;
    }
    let bookName = this.renderBookname(bookPrettyName);
    return (
      <div className="card-large">
        <Link to={to} className="card-large-img" onClick={this.checkEnabled}>
          {this.renderImg(img)}
        </Link>
        <div className="description">
          <Link to={to} className="card-large-txt" onClick={this.checkEnabled}>
            {showTooltip ? this.renderTooltipWrapper(textTop, bookName) : bookName}
            <div className="students">{textBottom}</div>
          </Link>
          <div className="options">{this.renderDropDown()}</div>
        </div>

        {renderLoadBar ? renderLoadBar() : ''}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    colors: state.theme.colors
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(CardLarge);
